/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRoamingCheckRegEmailGet } from '../fn/check/api-roaming-check-reg-email-get';
import { ApiRoamingCheckRegEmailGet$Params } from '../fn/check/api-roaming-check-reg-email-get';
import { apiRoamingCheckRegGet } from '../fn/check/api-roaming-check-reg-get';
import { ApiRoamingCheckRegGet$Params } from '../fn/check/api-roaming-check-reg-get';
import { CheckRegResponseApiRoaming } from '../models/check-reg-response-api-roaming';

@Injectable({ providedIn: 'root' })
export class ApiRoamingCheckService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRoamingCheckRegGet()` */
  static readonly ApiRoamingCheckRegGetPath = '/api/Roaming/CheckReg';

  /**
   * Check if a customer exists with the specified phone number.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingCheckRegGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingCheckRegGet$Response(params?: ApiRoamingCheckRegGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckRegResponseApiRoaming>> {
    return apiRoamingCheckRegGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Check if a customer exists with the specified phone number.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingCheckRegGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingCheckRegGet(params?: ApiRoamingCheckRegGet$Params, context?: HttpContext): Observable<CheckRegResponseApiRoaming> {
    return this.apiRoamingCheckRegGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CheckRegResponseApiRoaming>): CheckRegResponseApiRoaming => r.body)
    );
  }

  /** Path part for operation `apiRoamingCheckRegEmailGet()` */
  static readonly ApiRoamingCheckRegEmailGetPath = '/api/Roaming/CheckRegEmail';

  /**
   * Checking registration by email.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingCheckRegEmailGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingCheckRegEmailGet$Response(params?: ApiRoamingCheckRegEmailGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckRegResponseApiRoaming>> {
    return apiRoamingCheckRegEmailGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Checking registration by email.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingCheckRegEmailGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingCheckRegEmailGet(params?: ApiRoamingCheckRegEmailGet$Params, context?: HttpContext): Observable<CheckRegResponseApiRoaming> {
    return this.apiRoamingCheckRegEmailGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CheckRegResponseApiRoaming>): CheckRegResponseApiRoaming => r.body)
    );
  }

}
